var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Dark",
    cx: 9,
    cy: 5.25,
    r: 3,
    fill: "#6B47F5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Light",
    opacity: 0.2,
    cx: 9,
    cy: 12.75,
    rx: 5.25,
    ry: 3,
    fill: "#6B47F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSmall);
export default __webpack_public_path__ + "static/media/user-small.7e0ef4f7ece5087a2baa2d897d5f64f9.svg";
export { ForwardRef as ReactComponent };